@if (count()) {
  <div class="grid-selection-pill">
    <fa-icon [icon]="['fas', 'check-double']"></fa-icon>
    <span class="grid-selection-pill__count">
      {{ "grid.selection.selected" | translate }} ({{ count() }})
    </span>
    <button
      type="button"
      class="grid-selection-pill__clear"
      [title]="'btn.clear' | translate"
      (click)="clear()"
    >
      <fa-icon [icon]="['fas', 'times']"></fa-icon>
    </button>
  </div>
}
